import { render, staticRenderFns } from "./AdministrationSanitizationPgHeader.vue?vue&type=template&id=0185b2e1&scoped=true&"
import script from "./AdministrationSanitizationPgHeader.vue?vue&type=script&lang=js&"
export * from "./AdministrationSanitizationPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationSanitizationPgHeader.vue?vue&type=style&index=0&id=0185b2e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185b2e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
